import React, { useState, useEffect } from "react"
import { Navbar, Nav, Container, NavDropdown, Button } from 'react-bootstrap'
import { useHistory } from "react-router-dom"
import { useAuth } from "../contexts/AuthContext"
import { GetUser } from "../firebase/firebase"
export default function NavBar() {
    const history = useHistory()
    const [error, setError] = useState('')
    const [user, setUser] = useState('')
    const { currentUser, logout, userRole } = useAuth()

    async function handleLogout() {
        setError("")

        try {
            await logout()
            setUser('')
            history.push("/")
        } catch {
            setError("Failed to log out")
        }
    }

    useEffect(() => {
        if (currentUser) {
            GetUser(currentUser.uid).then((user) => {
                setUser(user.data())
            })
        }
    }, [currentUser])

    return (

        <>
            <Navbar  className='py-3' collapseOnSelect variant='dark' expand="lg" style={{ background: 'linear-gradient(to right, rgba(48, 207, 208, 1), rgba(51, 8, 103, 1))'}}>
                <Navbar.Brand className="mx-3" href="/">Nutrition Outreach</Navbar.Brand>
                <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                <Navbar.Collapse id="responsive-navbar-nav">
                    <Container>
                        <Nav>
                            <Nav.Link href="/">Home</Nav.Link>
                            <Nav.Link href='/recipes'>Recipes</Nav.Link>
                            <Nav.Link href='/blog'>Blog</Nav.Link>
                            <Nav.Link href="/forum">Forum</Nav.Link>
                            <Nav.Link href='media'>Media</Nav.Link>
                            <Nav.Link href="/mission">Mission</Nav.Link>
                        </Nav>
                    </Container>
                    <Container>




                        {currentUser ?
                            <Nav className='d-flex justify-content-end'>
                                {userRole === 'admin' || userRole ==='superAdmin' ?

                                    <Nav.Link className='mx-3 btn-primary text-white' href='/admin'>Admin</Nav.Link>
                                    :
                                    ""}
                                <Navbar.Text>Welcome, {user.firstName} </Navbar.Text>
                                <Nav.Link href='/profile'>View Profile</Nav.Link>
                                <Button onClick={handleLogout}>Logout</Button>
                            </Nav>
                            :
                            <Nav className='d-flex justify-content-end'>
                                <Nav.Link href='/login'>Login</Nav.Link>
                                <Nav.Link href='/signup'>Signup</Nav.Link>
                            </Nav>
                        }




                    </Container>
                </Navbar.Collapse>
            </Navbar>
        </>





    )
}